import CloseTitle from './Titles/CloseTitle';
import DialogTitle from './Titles/DialogTitle';
import InfoContent from './Contents/InfoContent';
import ModalDialog from './ModalDialog';

export { ModalDialog, CloseTitle, DialogTitle, InfoContent };
export default ModalDialog;
